import { CHANGE_MODEL } from "../constants";

export const changeModel = (model) => ({
	type: CHANGE_MODEL,
	payload: model,
});
